import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
export const RiskMeter = ({ score, level, size = 'md' }) => {
    const getColor = () => {
        switch (level) {
            case 'CRITICAL':
                return 'text-red-600';
            case 'HIGH':
                return 'text-orange-500';
            case 'MEDIUM':
                return 'text-yellow-500';
            case 'LOW':
                return 'text-green-500';
            case 'INFO':
                return 'text-blue-500';
        }
    };
    const getBgColor = () => {
        switch (level) {
            case 'CRITICAL':
                return 'bg-red-600/20';
            case 'HIGH':
                return 'bg-orange-500/20';
            case 'MEDIUM':
                return 'bg-yellow-500/20';
            case 'LOW':
                return 'bg-green-500/20';
            case 'INFO':
                return 'bg-blue-500/20';
        }
    };
    const getStrokeColor = () => {
        switch (level) {
            case 'CRITICAL':
                return '#DC2626';
            case 'HIGH':
                return '#F97316';
            case 'MEDIUM':
                return '#EAB308';
            case 'LOW':
                return '#22C55E';
            case 'INFO':
                return '#3B82F6';
        }
    };
    const sizeClass = size === 'sm' ? 'w-12 h-12' : size === 'lg' ? 'w-24 h-24' : 'w-16 h-16';
    const sizeNum = size === 'sm' ? 48 : size === 'lg' ? 96 : 64;
    const circumference = 2 * Math.PI * 28; // radius = 28
    const strokeDashoffset = circumference - (score / 100) * circumference;
    return (_jsxs("div", { className: clsx('flex flex-col items-center gap-2'), children: [_jsxs("div", { className: clsx('relative flex items-center justify-center', sizeClass), children: [_jsxs("svg", { className: "absolute", width: sizeNum, height: sizeNum, viewBox: `0 0 ${sizeNum} ${sizeNum}`, children: [_jsx("circle", { cx: sizeNum / 2, cy: sizeNum / 2, r: "28", fill: "none", stroke: "currentColor", strokeWidth: "3", className: "text-gray-700" }), _jsx("circle", { cx: sizeNum / 2, cy: sizeNum / 2, r: "28", fill: "none", stroke: getStrokeColor(), strokeWidth: "3", strokeDasharray: circumference, strokeDashoffset: strokeDashoffset, strokeLinecap: "round", style: { transition: 'stroke-dashoffset 0.5s ease' }, transform: `rotate(-90 ${sizeNum / 2} ${sizeNum / 2})` })] }), _jsx("div", { className: clsx('text-center relative z-10', getColor()), children: _jsxs("div", { className: "font-bold", style: { fontSize: size === 'sm' ? '12px' : size === 'lg' ? '24px' : '16px' }, children: [score, "%"] }) })] }), _jsx("div", { className: clsx('text-sm font-medium', getColor()), children: level })] }));
};
